import js from '../assetes/image/javascript.png';
import prog from '../assetes/image/programming.jpg';
import react from '../assetes/image/react.png';
export const blogService = [
    {
        id: 1,
        title: 'JavaScript core concept',
        description: "JavaScript is a dynamic programming language that's used for web development,It allows you to implement dynamic.....",
        goLink: 'JavaScript core concept',
        img: js,
        blog: 'https://mdzamanrabin.medium.com/javascript-behind-the-scene-a2a8f03aec66',
    },
    {
        id: 2,
        title: 'Introduce with Programming',
        description: 'Simply describe what is programming. Why we should learn programming and how to learn programming in Bangla',
        goLink: 'Learn Programming',
        img: prog,
        blog: 'https://bdtechfarm.blogspot.com/2018/12/introduction-to-programming.html',
    },
    {
        id: 3,
        title: 'Simple Introduce to React.js',
        description: 'React is library that use to create awesome user interface. React JS is use to create single page application.React is more interactive UI',
        goLink: 'introduce with React JS',
        img: react,
        blog: 'https://mdzamanrabin.medium.com/introduce-to-react-js-fd560d39c6d2'
    },
]